import {gql} from "@irati/utils/gql"

export default gql`
  mutation AddUserToTeam($teamId: ID!, $userId: ID!, $assignment: TeamAssignment) {
    addUserToTeam(teamId: $teamId, userId: $userId, assignment: $assignment)
  }
`
